import { useEffect } from "react";
import socketService from "./socket";
import { useSession } from "@/services/auth0/session";

/**
 * This hook ensures the SocketService is physically connected on mount,
 * and optionally closed on unmount.
 *
 * Options:
 * - closeOnUnmount: if true, call socketService.closeSocket() in cleanup
 */
interface UseSocketSetupOptions {
  closeOnUnmount?: boolean;
}

export function useSocketSetup(options: UseSocketSetupOptions = {}) {
  const { token, isLoggedIn, isLoading } = useSession();

  useEffect(() => {
    // Only connect when we have a token and user is logged in
    if (!isLoading && isLoggedIn && token) {
      socketService.connect(token);

      return () => {
        if (options.closeOnUnmount) {
          socketService.disconnect();
        }
      };
    }
  }, [isLoading, isLoggedIn, token, options.closeOnUnmount]);
}
